import { queryOptions } from "@tanstack/react-query";

import { getCoachProgress } from "~/lib/functions/coach-progress";

export function coachProgressQueryOptions() {
  return queryOptions({
    queryKey: ["coach", "progress"],
    queryFn: () => getCoachProgress(),
  });
}
